import { render, staticRenderFns } from "./LoginMessage.vue?vue&type=template&id=67532be6"
import script from "./LoginMessage.vue?vue&type=script&lang=js"
export * from "./LoginMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports